<template>
  <QuestionBase :errors="[...serverErrors, ...jsErrors]"
                :question="question"
                :valid="data !== null">
    <InputRadio v-model="data"
                :args="args"
                :db="db"
                :options="booleanYesNo"
                :skipped="skipped"
                @jsErrors="jsErrors=$event"
                @serverErrors="serverErrors=$event"
                @skipped="skipped=$event" />
  </QuestionBase>
</template>

<script>
import { lpaRelationshipHelpers } from "@/components/common/questionnaires/fieldsets/lpa/helpers/lpaRelationshipHelpers";
import { lpaPartnerHelpers } from "@/components/common/questionnaires/fieldsets/lpa/helpers/lpaPartnerHelpers";
import { questionLoadHelpers} from "@/components/common/questionnaires/question/helpers/questionLoadHelpers";
import { general} from "@/components/common/questionnaires/question/options/general";

import QuestionBase from "@/components/common/questionnaires/question/QuestionBase";
import InputRadio from "@/components/common/questionnaires/question/inputs/InputRadio";

export default {
  name: 'PartnerHealthPrimaryAttorneyYN',
  mixins: [
    general,
    questionLoadHelpers,
    lpaPartnerHelpers,
    lpaRelationshipHelpers
  ],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    },
    question() {
      return {
        title: `Do you wish to appoint ${this.partner.name_first} ${this.partner.name_last} as the primary attorney to make decisions regarding health and welfare?`,
        subTitle: `It is usual to have your partner make decisions about your medical treatment, where you live, and your day-to-day care if you lose the mental capacity to make these decisions yourself. Consider whether your partner or spouse understands your wishes regarding medical care and end-of-life decisions.`,
        tip: null,
      }
    }
  },
  data() {
    return {
      db: {
        saveLocation: 'product_lpa_data',
        saveField: 'primaryPartnerAttorneysHealth',
        formPath: 'data.attorneys.health.details.primaryPartner',
        jsonSaveField: 'primaryPartner'
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
